<template>
  <span
    class="inlineblock width100 yellowfont minfont widthStyle"
    v-html="content"/>
</template>

<script>
  export default {
    name: 'PText',
    props: {
      content: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },
    methods: {
      initData() {
      },
      loadData() {
      }
    }
  }
</script>

<style lang="less" scoped>
.inlineblock {
  display: inline-block;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.widthStyle {
  word-wrap: break-word;
}
</style>
